var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticStyle:{"max-width":"92%","width":"500px","display":"flex","flex-direction":"column","flex-grow":"1","height":"100%"}},[_c('v-progress-circular',{staticClass:"absolute-center",attrs:{"indeterminate":"","color":"secondary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }